import { ArrowLeft, ArrowRight, SkipForward } from 'lucide-react';

interface GameControlsProps {
  onPrevious: () => void;
  onSkip: () => void;
  onNext: () => void;
}

export const GameControls: React.FC<GameControlsProps> = ({
  onPrevious,
  onSkip,
  onNext,
}) => {
  const handleBlur = (e: React.MouseEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).blur(); // Remove focus after click
  };

  return (
    <div className="flex justify-center gap-4">
      <button
        onClick={(e) => {
          handleBlur(e);
          onPrevious();
        }}
        className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors"
        title="Previous question (←)"
      >
        <ArrowLeft className="w-6 h-6" />
      </button>
      <button
        onClick={(e) => {
          handleBlur(e);
          onSkip();
        }}
        className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors"
        title="Skip question (S)"
      >
        <SkipForward className="w-6 h-6" />
      </button>
      <button
        onClick={(e) => {
          handleBlur(e);
          onNext();
        }}
        className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors"
        title="Show answer/Next question (→ or Space)"
      >
        <ArrowRight className="w-6 h-6" />
      </button>
    </div>
  );
};